import React, { useState } from "react";
import arrowDownIcon from "@src/assets/svg/arrow-down.svg";
import SpinnerWithVariant from "@src/components/atoms/SpinnerWithVariant/spinner-with-variant";
import styles from "@src/components/atoms/admin-panel-organization-dropdown/admin-panel-organization-dropdown.module.scss";

const cssClassName = "admin-panel-organization-dropdown";

interface AdminPanelOrganizationDropdownProps {
  isLoading: boolean;
  label: string;
  onChange: (organizationId: string) => void;
  options: Record<string, string>;
  placeholder: string;
  selectedId: string;
}

export const AdminPanelOrganizationDropdown = ({
  isLoading,
  label,
  onChange,
  options,
  placeholder,
  selectedId,
}: AdminPanelOrganizationDropdownProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const selectedName = options[selectedId];

  return (
    <div aria-busy={isLoading}>
      <div className={styles[cssClassName]}>
        <div className={styles[`${cssClassName}__label`]}>{label}</div>
        <button
          aria-controls={`${cssClassName}-options`}
          aria-expanded={isOpen}
          aria-haspopup="listbox"
          aria-label={label}
          className={styles[`${cssClassName}__trigger`]}
          onClick={() => setIsOpen((open) => !open)}
          role="combobox"
          type="button"
        >
          <span
            className={
              selectedName
                ? styles[`${cssClassName}__value`]
                : styles[`${cssClassName}__placeholder`]
            }
          >
            {selectedName || placeholder}
          </span>
          <img alt="" aria-hidden="true" src={arrowDownIcon} />
        </button>
        {isOpen && (
          <ul
            aria-busy={isLoading}
            className={styles[`${cssClassName}__options`]}
            id={`${cssClassName}-options`}
            role="listbox"
          >
            {isLoading ? (
              <li role="presentation">
                <div role="status">
                  <SpinnerWithVariant variant="small" />
                </div>
              </li>
            ) : (
              Object.entries(options).map(([id, name]) => (
                <li key={id} role="presentation">
                  <button
                    aria-selected={selectedId === id}
                    className={styles[`${cssClassName}__option`]}
                    onClick={() => {
                      onChange(id);
                      setIsOpen(false);
                    }}
                    role="option"
                    type="button"
                  >
                    {name}
                  </button>
                </li>
              ))
            )}
          </ul>
        )}
      </div>
    </div>
  );
};
